import { Spinner, Wrapper } from './styles'

/**
 * 지역 정보 로딩 스피너.
 *
 * 첫 진입 시 regionList 또는 regionDetail 응답 대기 중에 본문 영역 자리를 잡고
 * 스피너 노출. staleTime: Infinity 로 한 번 받으면 캐시되므로, 같은 region 재진입
 * 또는 region 전환 시에는 즉시 캐시 표시 (스피너 안 뜸).
 */
export default function ContentSpinner() {
  return (
    <Wrapper
      role='status'
      aria-label='지역 정보 로딩 중'>
      <Spinner aria-hidden='true' />
    </Wrapper>
  )
}
